module.exports = __webpack_public_path__ + "static/img/tech-banner.bf9c426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tech-banner.png
// module id = 62ju
// module chunks = 8